// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__WL3we","amount":"Amount_amount__16qhb","tip":"Amount_tip__3w0SM","tipHeader":"Amount_tipHeader__2AVby","tipsWrap":"Amount_tipsWrap__1YFNk"};